import { createFileRoute } from '@tanstack/react-router'
import { adsRepository } from '@/data/adapters/api/ads.api'

const DEFAULT_RANGE = { from: new Date('2026-03-01'), to: new Date('2026-04-13') }

export const Route = createFileRoute('/$orgSlug/$clientSlug/ads')({
  loader: ({ context: { queryClient, client } }) =>
    queryClient.ensureQueryData({
      queryKey: ['ads', 'daily', client.id, DEFAULT_RANGE.from.toISOString(), DEFAULT_RANGE.to.toISOString()],
      queryFn: () => adsRepository.getDailyMetrics(client.id, DEFAULT_RANGE),
    }),
})
